import React, { Suspense, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import LoadingSpinner from "./components/_atoms/loadingSpinner/LoadingSpinner";
import { ConfigProvider } from "antd";
import faIR from "antd/es/locale/fa_IR";
import "./App.css";
import NotificationWrapper from "app/components/_core/notifications";
import { useAppDispatch } from "redux/reduxHook";
import { logoutUser } from "redux/user/userActions";
import Cookies from "js-cookie";
import request from "api/request";
import { ErrorBoundary } from "react-error-boundary";
import FallBackErrorBoundray from "./components/_core/error-boundray/FallBackErrorBoundray";
import { RoutesComponent } from "route/Routes";

const theme = {
  token: {
    fontFamily: "IRANSans",
    colorPrimary: "#02A0A4",
    colorLink: "#02A0A4",
    colorLinkHover: "#02A0A4",
    colorLinkActive: "#02A0A4",
    fontSize: 14,
    borderRadius: 6,
  },
  components: {
    Button: {
      fontSizeLG: 14,
    },
  },
};

function App() {
  const [resetErrorKey, setResetErrorKey] = useState(null);
  const dispatch = useAppDispatch();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: false,
        onError: async (error: any) => {
          if (error?.request?.status === 401) {
            Cookies.remove("token");
            request.setToken(null);
            dispatch(logoutUser());
          }
        },
      },
    },
  });

  return (
    <Suspense fallback={<>MSD</>}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider direction={"rtl"} locale={faIR} theme={theme}>
            <NotificationWrapper />
            <ErrorBoundary FallbackComponent={FallBackErrorBoundray} onReset={() => setResetErrorKey(null)} resetKeys={[resetErrorKey]}>
              <RoutesComponent />
            </ErrorBoundary>
          </ConfigProvider>
          <ReactQueryDevtools initialIsOpen={true} />
        </QueryClientProvider>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
